<template>
  <div class="wrap">
    <div class="phone-wrap">
      <div style="margin:0 auto;position:relative">
        <!-- <img src="../assets/image/phone_icon.png" alt="" width="" height="" class="phone-icon"> -->
        <input
          class="phone-in number input-text"
          type="tel"
          placeholder="输入手机号码"
          v-model="phone_num"
          maxlength="11"
          @click="td1()"
        />
      </div>
    </div>

    <div class="errorPrompt2">
      <div class="errorPrompt2" v-if="!ifCode">{{prompt}}</div>
    </div>

    <!-- <div class="re-button" @click="goCode" :style="{'opacity':canClick?1:1}"> -->
    <div class="re-button2" @click="goCode" :style="{'opacity':canClick?1:1}">
      <!-- 立即借款 -->
    </div>
    <div class="protocol" @click="()=>is_select=!is_select" v-if="protocol">
      <img v-show="is_select" src="https://h5stc.oss-cn-shanghai.aliyuncs.com/img/xuanze.png" alt />
      <img
        v-show="!is_select"
        src="https://h5stc.oss-cn-shanghai.aliyuncs.com/img/weixuanze.png"
        alt
      />
      同意并接受
      <!-- <span @click="go_to_protocol()">《{{protocol_name}}》</span> -->
      <span v-for="(item, index) in protocols" :key="index" @click="go_to_protocol(item.link)">《{{item.title}}》<span v-if="index!=(protocols.length-1)" style="color:#999">和</span></span>
    </div>

    <div class="ic-wrap" v-if="ifCode">
      <div class="ic-back" @click="()=>ifCode=false"></div>
      <div class="ic-content">
        <div style="position:relative">
          <img
            src="../assets/image/phone_icon.png"
            alt
            width
            height
            class="phone-icon"
            style="z-index:1"
          />

          <div style="margin:0 auto;position:relative;">
            <input
              class="phone-in input-code"
              type="text"
              style="text-align:left"
              placeholder="输入验证码"
              v-model="code"
              :maxlength="code_length"
              @click="td2()"
            />
          </div>
          <div class="for-code" @click="number_f" v-if="number_click">获取验证码</div>
          <div class="for-code" v-if="number_show">{{number}}秒后重发</div>
        </div>
        <div class="errorPrompt">{{prompt}}</div>
        <!-- <button ut-data-click ut-data-convertid="168468" ut-data-eventtype="CompleteRegistration" class="re-button" @click="re_button" :style="{'opacity':canClick2?1:.6}"> -->
        <div class="re-button" @click="re_button" :style="{'opacity':canClick2?1:.6}">立即借款</div>
      </div>
    </div>

    <div class="ic-wrap" v-if="oldNum">
      <div class="ic-back" @click="()=>oldNum=false"></div>
      <div class="ic-content">
        <div style="color:#000;line-height: 50px;font-size: 17px;">该号码已注册请下载登录</div>
        <div class="re-button" @click="oldButton">
          立即借款
          <!-- ({{three}}秒后自动下载) -->
        </div>
      </div>
    </div>

    <div class="ic-wrap" v-if="show_protocol">
      <div class="ic-back2" @click="()=>show_protocol=false"></div>
      <div class="protocol-alert">
        <div class="protocol-title">温馨提示</div>
        <div class="protocol-content">
          我们非常重视您的隐私保护和个人信息保护。请您认真阅读
          <!-- <span @click="go_to_protocol()">《{{protocol_name}}》</span>全部条款，同意并接受全部条款后再开始使用我们的服务。 -->
          <span v-for="(item, index) in protocols" :key="index" @click="go_to_protocol(item.link)">《{{item.title}}》<span v-if="index!=(protocols.length-1)" style="color:#000">和</span></span>全部条款，同意并接受全部条款后再开始使用我们的服务。
        </div>
        <div class="protocol-btn" @click="protocol_click()">同意</div>
      </div>
      <img
        class="ic-close-icon"
        @click="()=>show_protocol=false"
        src="https://h5stc.oss-cn-shanghai.aliyuncs.com/img/close.png"
        alt
      />
    </div>

    <div class="ic-wrap" v-if="show_popup">
      <div class="ic-back2" @click="()=>show_popup=false"></div>
      <div class="protocol-alert" style="padding:0">
        <img
          v-if="show_popup_1"
          :src="download_popup_1"
          alt
          style="width:100%;height:auto"
          class="popup-img-1"
        />
        <img
          v-if="show_popup_2"
          :src="download_popup_2"
          alt
          style="width:100%;height:auto"
          class="popup-img-1"
        />
        <div v-if="show_popup" class="popup-btn" @click="app_download(download_url)"></div>
      </div>
    </div>

    <!-- 顶部提示浏览器打开弹窗 -->
    <div class="guide_browser_open_popup" v-if="isShowGuideBrowserPopup">
      <img alt src="https://microsupload.oss-cn-shanghai.aliyuncs.com/land/images/guide_browser_popup_cG4Z7kO.png"/>
    </div>
  </div>
</template>


<script>
import { Toast, Indicator } from "mint-ui";
export default {
  name: "Register",
  data() {
    return {
      three: 3,
      canClick: false,
      msg: "",
      phone_num: "",
      code: "",
      number: 60,
      url_n: "",
      number_click: true,
      number_show: false,
      prompt: "",
      color: "",
      code_prompt: "",
      is_phone: false,
      is_code: "",
      model_show: false,
      cid: "",
      re_code: "",
      pwd: "",
      ifCode: false,
      canClick2: false,
      oldNum: false,
      oldUrl: "",
      isD: 123,
      sys: "",
      wechat: false,
      setTime: "",
      product_name: window.product_name,
      is_select: window.protocol_status == "0" ? false : true,
      protocol_name: window.protocol_name,
      protocol_link: window.protocol_link,
      protocol: window.protocol == "0" ? false : true,
      show_protocol: false,
      download_popup_1: window.download_popup_1,
      download_popup_2: window.download_popup_2,
      show_popup: false,
      show_popup_1: false,
      show_popup_2: false,
      download_url: "",
      deep_link: window.deep_link || false,
      isShowGuideBrowserPopup: false,
      code_length: window.code_max_length,
      code_length_list: window.code_length_list.toString().split(","),
      protocols: window.protocols
    };
  },
  watch: {
    phone_num(num) {
      let isP = /^1\d{10}$/.test(num);
      if (num.length == 11) {
        if (!isP) {
          this.canClick = false;
          this.is_phone = false;
          this.prompt = "请输入正确的手机号!";
          // this.color = "red"
        } else {
          this.prompt = "";
          this.is_phone = true;
          this.canClick = true;
          // this.prompt = '输入正确️!'
          // this.color = "green"
        }
      } else {
        this.canClick = false;
        this.is_phone = false;
        this.prompt = "";
      }
    },
    code(num) {
      if (this.code_length_list.includes(num.length.toString())) {
        this.canClick2 = true;
        this.prompt = "";
      } else {
        this.canClick2 = false;
      }
    }
  },

  created() {
    let number = document.cookie.match(/number=(\w+)/);
    number = (number && number[1]) || false;

    let mmUserLoginNumber = document.cookie.match(/mmUserLoginNumber=(\w+)/);
    mmUserLoginNumber = (mmUserLoginNumber && mmUserLoginNumber[1]) || false;
    if (mmUserLoginNumber) {
      // 直接跳转
      this.toOtherPath();
    }

    if (number) {
      this.canClick = true;
      this.phone_num = number;
      this.goCode();
    }

    let m =
      location.search.match(/cid=(\w+)/) ||
      location.search.match(/td_channelid=(\w+)/);
    this.cid = (m && m[1]) || "test";
  },

  methods: {
    pathMap(step, is_new) {
      document.cookie = "mmUserLoginNumber=" + this.phone_num + ";path=/;";
      window.mmIsNewUser = is_new ? true : false;
      let stepMap = {
        auth_name: "Authidcard",
        profiles: "Details",
        download: "Assess"
      };
      this.$router.replace({
        path: stepMap[step]
      });
    },
    toOtherPath() {
      let url = process.env.API_ROOT + "/h5half/step";
      this.$http.post(url, { source: window.half_source }).then(
        data => {
          if (data.data.step) {
            this.pathMap(data.data.step, data.data.is_new);
          }
        },
        data => {
          document.cookie =
            "mmUserLoginNumber=" +
            this.phone_num +
            ";path=/;expires=" +
            new Date(0).toUTCString();
        }
      );
    },
    show_popup_func(url, type) {
      this.download_url = url;
      if (type == 1) {
        this.show_popup_2 = false;
        this.show_popup_1 = true;
      } else {
        this.show_popup_1 = false;
        this.show_popup_2 = true;
      }
      this.show_popup = true;
    },
    app_download(url) {
      if (this.deep_link) {
        var myif = document.createElement("iframe");
        myif.src = this.deep_link;
        myif.style.display = "none";

        document.body.appendChild(myif);
        setTimeout(function() {
          location.href = url;
        }, 1000);
      } else {
        location.href = url;
      }
    },
    go_to_protocol(link) {
      location.href = link;
    },
    protocol_click() {
      this.is_select = true;
      this.goCode();
    },
    oldButton() {
      this.isD = 1;
      this.app_download(this.oldUrl);
    },
    td1() {
      TDAPP.onEvent("点击手机号输入框");
    },
    td2() {
      TDAPP.onEvent("点击验证码输入框");
    },
    goCode() {
      if (!this.is_select) {
        this.show_protocol = true;
        return;
      }
      this.show_protocol = false;
      if (sessionStorage[this.phone_num]) {
        if (this.download_popup_1) {
          this.show_popup_func(sessionStorage[this.phone_num], 1);
          return;
        }
        this.app_download(sessionStorage[this.phone_num]);
        return;
      }
      if (!this.canClick) {
        this.prompt = "请输入正确手机号";
        return;
      }
      let cookie_code = document.cookie.match(/code=(\w+)/);

      cookie_code = (cookie_code && cookie_code[1]) || false;
      if (cookie_code) {
        this.code = cookie_code;
        this.re_button();
      }
      this.number_f();
    },
    downUrl(data) {
      let a = data.indexOf("?");
      let b = data.indexOf("cid");
      let c = data.indexOf("td_channelid");

      if (a == -1) {
        if (b == -1 && c == -1) {
          data = data + "?td_channelid=" + this.cid;
        }
      } else {
        if (b == -1 && c == -1) {
          data = data + "&td_channelid=" + this.cid;
        }
      }
      return data;
    },
    number_f() {
      TDAPP.onEvent("点击获取验证码");
      if (this.is_phone) {
        this.number = 60;
        this.number_click = false;
        this.number_show = true;
        clearInterval(this.setTime);
        this.setTime = setInterval(() => {
          this.number--;
          if (this.number === 0) {
            this.number_show = false;
            this.number_click = true;
            clearInterval(this.setTime);
          }
        }, 1000);
        let agent = window.navigator.userAgent;
        let isWechat = /MicroMessenger/.test(agent);
        let isIOS = /iPad|iPhone|iPod/.test(agent) && !window.MSStream;
        let isAndroid = /Android/i.test(agent) && !window.MSStream;
        let sys = isWechat ? "wechat" : isIOS ? "ios" : "android";
        this.sys = sys;

        let this_params = { number: this.phone_num, case: "register" };

        if (sessionStorage[this.phone_num]) {
          this.app_download(sessionStorage[this.phone_num]);
          return;
        }
        // let url = process.env.API_ROOT + "/code/code"
        let url = process.env.API_ROOT + "/h5half/code";
        this.$http.post(url, this_params).then(
          data => {
            TDAPP.onEvent("发送验证码成功");
            this.prompt = "";
            this.model_show = true;
            if (isWechat && isAndroid) {
              this.showGuidePopup();
            } else if (isWechat && !data.data.status) {
              sessionStorage[this.phone_num] = data.data;
              document.cookie = "number=" + this.phone_num + ";path=/;";
              this.download_url = data.data;
              if (this.download_popup_1) {
                let wx_down_url = this.downUrl(data.data);
                this.show_popup_func(wx_down_url, 1);
                return;
              }
              let n_url = this.downUrl(data.data);
              this.app_download(n_url);
              return;
            } else if (data.data.status) {
              this.timing(2);
            } else {
              this.oldUrl = data.data;
              this.timing(1);
            }

            clearTimeout(setTO);
            let setTO = setTimeout(() => {
              this.model_show = false;
            }, 1000);
          },
          err => {
            TDAPP.onEvent("发送验证码失败");
            this.prompt = "发送失败，请稍后重试!";
            if (err.data.error) {
              this.prompt = err.data.error;
            }
            this.model_show = true;
            clearTimeout(setTO);
            let setTO = setTimeout(() => {
              this.model_show = false;
            }, 1000);
          }
        );
      } else {
        if (this.phone_num != "") {
          this.prompt = "请输入正确的手机号!";
        } else {
          this.prompt = "手机号不能为空!";
        }

        this.model_show = true;
        clearTimeout(setTO);
        let setTO = setTimeout(() => {
          this.model_show = false;
        }, 1000);
      }
    },
    timing(data) {
      if (data == 1) {
        // this.oldNum = true;
        document.cookie = "number=" + this.phone_num + ";path=/;";
        sessionStorage[this.phone_num] = this.oldUrl;
        if (this.download_popup_1) {
          this.show_popup_func(this.oldUrl, 1);
          return;
        }
        this.app_download(this.oldUrl);
        this.isD = 123;
      } else {
        this.ifCode = true;
      }
    },

    re_button() {
      TDAPP.onEvent("点击申请下载按钮");
      // if (!this.canClick2) {
      //   return;
      // }
      // console.log(this.canClick)
      if (!this.canClick) {
        this.prompt = "请输入正确手机号";
        return;
      }
      // console.log(this.canClick)
      let agent = window.navigator.userAgent;
      let isWechat = /MicroMessenger/.test(agent);
      let isIOS = /iPad|iPhone|iPod/.test(agent) && !window.MSStream;
      let isAndroid = /Android/i.test(agent) && !window.MSStream;
      let sys = isWechat ? "wechat" : isIOS ? "ios" : "android";

      let this_params = {
        number: this.phone_num,
        code: this.code,
        source: window.half_source
      };

      if (this.code == "") {
        this.prompt = "请刷新重试!";
        this.model_show = true;
        clearTimeout(setTO);
        let setTO = setTimeout(() => {
          this.model_show = false;
        }, 1000);
      } else {
        Indicator.open();
        //获取下载地址
        // let url = process.env.API_ROOT + "/land/apply"
        let url = process.env.API_ROOT + "/h5half/codeverify";

        this.$http.post(url, this_params).then(
          data => {
            Indicator.close();
            TDAPP.onEvent("汽车之家注册");
            TDAPP.onEvent("获取下载地址");
            window.other_click();
            document.cookie = "number=" + this.phone_num + ";path=/;";

            if (data.data.step) {
              this.pathMap(data.data.step, data.data.is_new);
              return;
            }
            if (isWechat) {
              if (isAndroid) {
                this.showGuidePopup();
                return;
              } else {
                if (this.download_popup_2) {
                  let wx_down_url = this.downUrl(data.data);
                  this.show_popup_func(wx_down_url, 2);
                  return;
                }
                this.app_download(this.downUrl(data.data));
                return;
              }
            }

            if (this.download_popup_2) {
              this.show_popup_func(data.data, 2);
              this.canClick2 = false;
              this.prompt = "";
              this.ifCode = false;
              return;
            }
            this.app_download(data.data);
            this.canClick2 = false;
            this.prompt = "";
            this.ifCode = false;
          },
          err => {
            Indicator.close();
            TDAPP.onEvent("获取下载地址失败");

            this.prompt = "请刷新重试!";
            if (err.data.error) {
              this.prompt = err.data.error;
            }
            this.model_show = true;
            clearTimeout(setTO);
            let setTO = setTimeout(() => {
              this.model_show = false;
            }, 1000);
          }
        );
      }
    },
    showGuidePopup() {
      this.isShowGuideBrowserPopup = true;
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
input::-webkit-input-placeholder {
  color: #a7a7a7;
  font-size: 0.48rem;
  line-height: 110%;
}
input::-moz-placeholder {
  /* Mozilla Firefox 19+ */
  color: #a7a7a7;
  font-size: 0.48rem;
  line-height: 110%;
}
input:-moz-placeholder {
  /* Mozilla Firefox 4 to 18 */
  color: #a7a7a7;
  font-size: 0.48rem;
  line-height: 110%;
}
input:-ms-input-placeholder {
  /* Internet Explorer 10-11 */
  color: #a7a7a7;
  font-size: 0.48rem;
  line-height: 110%;
}
.input-code::-webkit-input-placeholder {
  color: red;
}
.input-code::-moz-placeholder {
  /* Mozilla Firefox 19+ */
  color: red;
}
.input-code:-moz-placeholder {
  /* Mozilla Firefox 4 to 18 */
  color: red;
}
.input-code:-ms-input-placeholder {
  /* Internet Explorer 10-11 */
  color: red;
}
.wrap {
  /* height: 8rem; */
}
input {
  box-sizing: border-box;
  outline: none;
  margin: 0 auto;
  height: 1.2rem;
  /* width: 16rem; */
  /* padding: 0 2rem; */
  border-radius: 0.7rem;
  width: 100%;
  /* border: 1px solid #dedede; */
  padding: 0 0.5rem;
  font-size: 0.48rem;
  text-align: left;
}
.input-code {
  box-sizing: border-box;
  outline: none;
  margin: 0 auto;
  height: 1.3rem;
  /* width: 16rem; */
  /* padding: 0 2rem; */
  border-radius: 0.7rem;
  width: 100%;
  border: 1px solid #dedede;
  padding: 0 0.5rem;
  font-size: 0.48rem;
  text-align: center;
  color: #000;
}
.input-text {
  background: none;
}
.phone-in {
  /* background: red;
  opacity: .3; */
}
.phone-wrap {
  /* height: 3rem; */
  position: relative;
}
.for-code {
  font-size: 0.5rem;
  position: absolute;
  left: 50%;
  top: 50%;
  margin-top: -0.45rem;
  margin-left: 1rem;
  /* height: 2rem; */
  width: 3rem;
  text-align: center;
  color: #000;
  line-height: 1rem;
  /* border-radius: 1rem; */
  border-left: 1px solid #ff6100;
}
.prompt {
  font-size: 0.1rem;
  width: 15rem;
  height: 1rem;
  line-height: 1rem;
  margin: 0 auto;
  text-align: left;
}
.model {
  position: fixed;
  left: 50%;
  top: 50%;
  width: 15rem;
  height: 2rem;
  line-height: 2rem;
  text-align: center;
  margin-left: -7.5rem;
  margin-top: -1rem;
  font-size: 0.6rem;
  background: #000;
  opacity: 0.4;
  color: #fff;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.re-button {
  box-sizing: border-box;
  height: 1.3rem;
  width: 100%;
  line-height: 1.3rem;
  border-radius: 0.7rem;
  margin: 0 auto;
  background: #fa8800;
  color: #fff;
  position: relative;
  font-size: 0.48rem;
  font-weight: bold;
  margin-top: 0;
}
.re-button2 {
  box-sizing: border-box;
  height: 1.3rem;
  width: 100%;
  line-height: 1.3rem;
  border-radius: 0.7rem;
  margin: 0 auto;
  /* background:red; */
  /* color: #fff; */
  position: relative;
  font-size: 0.48rem;
  font-weight: bold;
  margin-top: 0;
}
.phone-icon,
.code-icon {
  position: absolute;
  left: 0.8rem;
  top: 0.5rem;
  height: 1rem;
  width: 0.7rem;
  background-size: 100% 100%;
}
.code-icon {
  width: 0.9rem;
  left: 0.7rem;
}
.errorPrompt {
  text-align: center;
  color: red;
  font-size: 16px;
  height: 24px;
}
.errorPrompt2 {
  text-align: center;
  /* padding-left: 16px; */
  color: #fa6a40;
  font-size: 0.44rem;
  height: 0.8rem;
  line-height: 0.8rem;
}
.phone-icon {
  position: absolute;
  left: 0.5rem;
  top: 0.45rem;
  height: 0.6rem;
  width: auto;
  /* z-index: 1; */
}
.number {
  text-indent: 0.8rem;
}
.bottom-img {
  width: 100%;
  padding: 10px;
  box-sizing: border-box;
  margin: 10px 0;
  margin-bottom: 50px;
  margin-top: 20px;
}
.ic-wrap {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: 111111;
}
.ic-back,
.ic-back2 {
  width: 100%;
  height: 100%;
  background: #000;
  opacity: 0.4;
}
.ic-back2 {
  opacity: 0.72;
}
.ic-content {
  background: #fff;
  position: absolute;
  left: 5%;
  top: 50%;
  width: 90%;
  padding: 20px 5%;
  border-radius: 10px;
  box-sizing: border-box;
  margin-top: -80px;
}
.ic-content input {
  border-color: #ff6100;
  text-indent: 0.6rem;
}
.wx-img {
  position: fixed;
  right: 0;
  top: 0;
  width: 220px;
  z-index: 1111111111111111;
}
.protocol {
  padding-top: 0.06rem;
  font-size: 0.34rem;
  color: #999999;
}
.protocol img {
  height: 0.3rem;
  width: auto;
}
.protocol span {
  color: #fba535;
}
.protocol-alert {
  position: fixed;
  top: 4.2rem;
  left: 50%;
  background: #fff;
  width: 8.8rem;
  margin-left: -4.4rem;
  border-radius: 0.3rem;
  padding: 1.08rem 0.65rem;
  box-sizing: border-box;
}
.protocol-title {
  font-size: 0.66rem;
  font-family: PingFangSC;
  font-weight: 500;
  color: rgba(34, 34, 34, 1);
  text-align: left;
  margin-bottom: 0.58rem;
}
.protocol-content {
  color: #444444;
  font-size: 0.44rem;
  text-align: left;
}
.protocol-content span {
  color: #ff9c1a;
}
.protocol-btn {
  margin-top: 1.3rem;
  font-size: 0.46rem;
  font-family: PingFangSC;
  font-weight: 500;
  color: rgba(255, 255, 255, 1);

  width: 7.63rem;
  height: 1.3rem;
  line-height: 1.3rem;
  background: linear-gradient(
    270deg,
    rgba(252, 140, 0, 1) 0%,
    rgba(253, 185, 0, 1) 100%
  );
  border-radius: 0.64rem;
}
.ic-close-icon {
  position: fixed;
  top: 14.8rem;
  left: 50%;
  width: 0.78rem;
  height: auto;
  margin-left: -0.39rem;
}
.popup-btn {
  position: absolute;
  bottom: 0rem;
  left: 0rem;
  z-index: 99;
  height: 2.4rem;
  width: 100%;
}
.guide_browser_open_popup {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9111111111111111;
  width: 100%;
}
.guide_browser_open_popup img {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/Register.vue